import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {TableComp} from 'sz-react-utils'
import moment from 'moment'
import {
    Card,
    Tooltip,
    Popconfirm,
    notification,
    Button,
    Tag,
} from 'antd'
import Request from '../../../request'
import {connect} from 'react-redux'
import {getUrlPushWrapper} from '../../../routes'

class ProductionOrderFormList extends Component {

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.state = {currentPage: 1}
    }

    apiRequest = (params) => {
        if (params.page) {
            this.state.currentPage = params.page
        }
        if (!params.sortOrder) {
            params.sortField = 'productionOrderId'
            params.sortOrder = 'desc'
        }
        return new Promise(async (resolve) => {
            let data = await Request.productionOrderFormList({
                ...params,
                regExFilters: ['product', 'productionTeam', 'unitOfMeasurement'],
            })
            this.setState({count: data.total})
            resolve(data)
        })
    }

    delete = async (data) => {
        this.setState({loading: true})
        let x = await Request.deleteProductionOrderForm(data)
        this.setState({loading: false})
        this.table.current.reload()
        if (!x.error) {
            notification.success({message: x.message})
        } else {
            notification.error({message: x.message || 'Error in deleting'})
        }
    }

    render() {
        const {dispatch} = this.props
        const {currentPage} = this.state

        const columns = [
            {
                title: 'S.No',
                dataIndex: 'sno',
                width: 60,
                key: 'sno',
                fixed: 'left',
                render: (value, item, index) => (currentPage - 1) * 10 + index + 1,
            },
            {
                title: 'Production Order Id',
                dataIndex: 'productionOrderId',
                key: 'productionOrderId',
                width: 150,
                fixed: 'left',
                searchTextName: 'productionOrderId',
            },
            {
                title: 'Product',
                dataIndex: 'product',
                key: 'product',
                searchTextName: 'product',
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                key: 'quantity',
                width: 100,
            },
            {
                title: 'Unit',
                dataIndex: 'unitOfMeasurement',
                key: 'unitOfMeasurement',
                width: 100,
            },
            {
                title: 'Priority',
                dataIndex: 'priority',
                key: 'priority',
                width: 110,
                filters: [
                    {text: 'High', value: 'High'},
                    {text: 'Normal', value: 'Normal'},
                ],
                render: (val) => val ? <Tag color={val === 'High' ? 'red' : 'blue'}>{val}</Tag> : '',
            },
            {
                title: 'Production Team',
                dataIndex: 'productionTeam',
                key: 'productionTeam',
                searchTextName: 'productionTeam',
            },
            {
                title: 'Created Date',
                dataIndex: 'createdDate',
                key: 'createdDate',
                width: 140,
                searchDateName: 'createdDate',
                render: (text) => text ? <Tag>{moment(text).format('DD-MM-YYYY')}</Tag> : '',
            },
            {
                title: 'Expected Completion',
                dataIndex: 'expectedCompletionDate',
                key: 'expectedCompletionDate',
                width: 160,
                searchDateName: 'expectedCompletionDate',
                render: (text) => text ? <Tag>{moment(text).format('DD-MM-YYYY')}</Tag> : '',
            },
            {
                title: 'Remarks',
                dataIndex: 'remarks',
                key: 'remarks',
            },
            {
                key: 'actions',
                title: 'Actions',
                fixed: 'right',
                width: 100,
                render: (val, record) => {
                    return (
                        <React.Fragment>
                            <Tooltip title="Edit">
                                <Button
                                    shape="circle"
                                    size="small"
                                    style={{marginRight: 6}}
                                    icon="edit"
                                    onClick={() => {
                                        dispatch(
                                            getUrlPushWrapper('productionOrderFormEdit', {
                                                id: record._id,
                                            })
                                        )
                                    }}
                                />
                            </Tooltip>
                            <Tooltip title="Delete">
                                <Popconfirm
                                    title="Are you sure to delete?"
                                    onConfirm={() => this.delete({_id: record._id})}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        size="small"
                                        type="danger"
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </React.Fragment>
                    )
                },
            },
        ]

        return (
            <PageHeaderWrapper
                title={this.state.count ? `Production Order List: ${this.state.count}` : `Production Order List`}>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{scroll: {x: 1400}}}
                        pagination={{
                            ...this.state.pagination,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '25', '50', '100'],
                            showSizeChanger: true,
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    loading: global.buttonLoading,
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch,
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductionOrderFormList)
